export const COLUMN_KEY_REMOVE = '@@op/remove'
export const COLUMN_KEY_EDIT = '@@op/edit'

